export default {
  zh: {
    title: '无法连接线路，提示“创建 VPN 服务失败”，该怎么办？',
    content: [
      '1) 可能是没有给到 Plex 加速器相关的权限导致的，请卸载客户端重新安装，首次连接时提示是否允许创建 VPN 连接，点击允许即可。',
      '2) 可能是您的手机上安装了其他同类软件并开启了“始终开启 VPN ”功能。请打开手机设置- VPN 管理界面，找到该应用并停用“始终开启 VPN”,然后重新连接线路试试。'
    ]
  },
  en: {
    title: 'When I connect to the server, it shows "unable to create a VPN service", what should I do to solve it?',
    content: [
      '1) Please delete PlexVPN and reinstall it. When the VPN connection dialog box appears, select the "I trust this application" checkbox, please tap OK.',
      '2) It might because you have installed another VPN software and enabled the "Always-On" function. Please open your Phone settings - VPN page to check about it. If so, please turn off the "Always-On" function, then reconnect to the server to have a try.'
    ]
  }
}


// WEBPACK FOOTER //
// ./src/views/app/vpnPermissionDeniedFAQ/lang.js